/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Status_Failed6Inputs */

const en__field__enum_status_failed6 = /** @type {(inputs: _Field__Enum_Status_Failed6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

/** @type {(inputs: _Field__Enum_Status_Failed6Inputs) => LocalizedString} */
const de__field__enum_status_failed6 = en__field__enum_status_failed6;

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {_Field__Enum_Status_Failed6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_status_failed6 = /** @type {((inputs?: _Field__Enum_Status_Failed6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Status_Failed6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_status_failed6(inputs)
	return de__field__enum_status_failed6(inputs)
});
export { _field__enum_status_failed6 as "_field__enum_status_FAILED" }